import React from 'react';

import FormikDateInputsRow from 'components/Common/Formik/Row/FormikDateInputsRow';
import { getClasses, RowBuilderProps } from '../RowBuilder';
import { DateField } from 'types/Field';

export default function RowDateInputsBuilder({
  field,
  styles,
}: RowBuilderProps): JSX.Element {
  const {
    classes,
    inputProps,
    label,
    autoComplete,
    disabled,
    name,
    placeholder,
    id,
    required,
    ...fieldByType
  } = field as DateField;

  return (
    <FormikDateInputsRow
      label={label}
      classes={getClasses(classes, styles)}
      inputProps={{
        name,
        disabled,
        autoComplete,
        placeholder,
        id,
        required,
        ...inputProps,
      }}
      {...fieldByType}
    />
  );
}
